import React, { useEffect, useState } from "react";
import { FaEdit, FaLock } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Badge, Card, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyKitPreparation from "./UpdateStudyKitPreparation";
import AddNewStudyKitPreparation from "./AddNewStudyKitPreparation";
import DeletedStudyKitPreparation from "./DeletedStudyKitPreparation";
import KitPreparationActivities from "./KitPreparationActivities";
import { studySiteManagementServices } from "../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";
import Moment from "react-moment";
import { studyTreatmentManagementServices } from "../../../../APIServices/CTMS/studyTreatmentManagementServices";
import { eiwrsKitTypeServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitTypeServices";
import ReleaseKitPreparation from "./ReleaseKitPreparation";
import RunQCKitPreparation from "./RunQCKitPreparation";
import { eiwrsDepotManagementServices } from "../../../../APIServices/EIWRS/eiwrsDepotManagementServices";
import { eiwrsKitBatchNumberServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitBatchNumberServices";
import { eiwrsKitMetadataServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";

const StudyKitPreparationDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3, toggle4, setToggle4 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [kitData, setKitData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [kitList, setKitList] = useState([]);
  const [kitCount, setKitCount] = useState(0);
  const [deletedStudyKitPreparation, setDeletedStudyKit] = useState([]);
  const [deletedStudyKitPreparationCount, setDeletedStudyKitCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [actionLoader, setActionLoader] = useState("");
  const [activeTab, setActiveTab] = useState("activities");
  const [kitId, setKitId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [kitActivity, setKitActivity] = useState([]);
  const [depotList, setDepotList] = useState([]);
  const [treatmentList, setTreatmentList] = useState([]);
  const [kitTypeList, setKitTypeList] = useState([]);
  const [kitBatchList, setKitBatchList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [kitActivityCount, setKitActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getStudyDepotRowData = async () => {
    let data = await eiwrsDepotManagementServices.getStudyDepotRowData("active", studyId, StudyMode)
    setDepotList(data?.data || [])
  }

  const getStudyTreatmentRowData = async () => {
    let data = await studyTreatmentManagementServices.getStudyTreatmentRowData("active", studyId)
    setTreatmentList(data?.data || [])
  }

  const getEIWRSKitTypeMetadataData = async () => {
    let data = await eiwrsKitTypeServices.getEIWRSKitTypeMetadataData("active", studyId)
    setKitTypeList(data?.data || [])
  }

  const getEIWRSKitBatchNumberMetadataData = async () => {
    let data = await eiwrsKitBatchNumberServices.getEIWRSKitBatchNumberMetadataData("active", studyId)
    setKitBatchList(data?.data || [])
  }

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(kitCount / itemsPerPage);

  const getStudyKitPreparationData = async (e) => {
    setLoading(true);
    let data = await eiwrsKitPreparationServices.getStudyKitPreparationData(
      studyId,
      "active",
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setKitList(data?.data || []);
    setKitCount(data?.count || 0);
    setLoading(false);
  };

  const getEIWRSKitMetadataData = async (e) => {
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "active",
      studyId,
    );
    setColumns(data?.data || []);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyKitPreparation = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsKitPreparationServices.getStudyKitPreparationData(
      studyId,
      "deleted",
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyKit(data?.data || []);
    setDeletedStudyKitCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyKitPreparation",
      studyId,
      kitData?.kitId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setKitActivity(data?.data || []);
    setKitActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [kitData]);

  useEffect(() => {
    getStudyDepotRowData();
    getStudyTreatmentRowData();
    getEIWRSKitTypeMetadataData();
    getEIWRSKitBatchNumberMetadataData();
    getEIWRSKitMetadataData();
  }, []);

  useEffect(() => {
    getStudyKitPreparationData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudyKitPreparation = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Site Kit!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        userData.mode = StudyMode;
        let data =
          await eiwrsKitPreparationServices.softDeleteRestoreStudyKitPreparation(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyKitPreparationData();
          setKitId("");
          getDeletedStudyKitPreparation();
          if (type === "restore") {
            getDeletedStudyKitPreparation(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  const statusConvertKitPreparation = async (id, status, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Kit!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setActionLoader(id)
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.status = status;
        userData.mode = StudyMode;
        let data =
          await eiwrsKitPreparationServices.statusConvertKitPreparation(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyKitPreparationData();
        }
        setActionLoader("")
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {(eiwrsPermission?.dbpCreateKitPreparation || eiwrsPermission?.liveCreateKitPreparation || eiwrsPermission?.qcCreateKitPreparation) &&
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add New"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setKitId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
                  }`}
              />
              <div className="vr"></div>
            </>
          }
          {kitCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        {(eiwrsPermission?.dbpCreateKitPreparation || eiwrsPermission?.liveCreateKitPreparation || eiwrsPermission?.qcCreateKitPreparation) &&
          <div className="hstack gap-2">
            {StudyMode === "DBP Mode" &&
              deletedStudyKitPreparationCount > 0 &&
              <button
                onClick={() => {
                  setToggle1();
                  getDeletedStudyKitPreparation(
                    pageNumberDeleted,
                    itemsPerPageDeleted
                  );
                }}
                className={`updateProfile`}
              >
                Deleted History
              </button>
            }
          </div>
        }
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={kitId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyKitPreparation kitBatchList={kitBatchList} kitTypeList={kitTypeList} treatmentList={treatmentList} depotList={depotList} getStudyKitPreparationData={getStudyKitPreparationData} />
          )}
          <>
            {loading ? (
              <PageLoader />
            ) : kitCount === 0 ? (
              <NoDataFoundTable MSG={"Study Kit not found!"} />
            ) : kitList?.length === 0 ? (
              <NoDataFoundTable MSG={"Search Study Kit not found!"} />
            ) : (
              <>
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      {columns?.filter(column => column?.isUnique === "yes")?.map((item, index) => (
                        <th onMouseDown={(e) => onMouseDown(e, 1 + index)}>
                          {item?.columnLabel}
                        </th>
                      ))}
                      <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 1)}>
                        Kit Number
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 2)}>
                        Kit Type
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 3)}>
                        Depot
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 4)}>
                        Batch Number
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 5)}>
                        Treatment
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 6)}>
                        Expiry DT
                      </th>
                      {columns?.filter(column => column?.isUnique === "no")?.map((item, index) => (
                        <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 7 + index)}>
                          {item?.columnLabel}
                        </th>
                      ))}
                      <th onMouseDown={(e) => onMouseDown(e, columns?.length + 7)}>
                        Status
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, columns?.length + 8)}
                      >
                        Action
                      </th>
                      {(eiwrsPermission?.dbpCreateKitPreparation || eiwrsPermission?.liveCreateKitPreparation || eiwrsPermission?.qcCreateKitPreparation) &&
                        <>
                          <th
                            onMouseDown={(e) => onMouseDown(e, columns?.length + 9)}
                            style={{ width: 45 }}
                            className="text-center"
                          >
                            Edit
                          </th>
                          <th
                            onMouseDown={(e) => onMouseDown(e, columns?.length + 10)}
                            style={{ width: 55 }}
                            className="text-center"
                          >
                            Delete
                          </th>
                        </>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {kitList?.map((kitData, index) => (
                      <tr
                        key={kitData?._id || index}
                        title="View Details"
                        className={`${kitData?.type !== "predefine" ? "CP" : ""} ${kitId === kitData?._id ? "highlighted" : ""
                          }`}
                        onClick={() => setIsFormOpen(false)}
                      >
                        <td
                          className="text-center"
                          onClick={() => {
                            setKitData(kitData);
                            setKitId(kitData?._id);
                          }}
                        >
                          {index + 1 + startIndex}
                        </td>
                        {columns?.filter(column => column?.isUnique === "yes")?.map(item => {
                          const columnData = (kitData?.columns || [])?.find(
                            (ele) => ele?.columnName === item?.columnName
                          );
                          return (
                            <td
                              key={item?.columnId || item?.columnName}
                              onClick={() => {
                                setKitData(kitData);
                                setKitId(kitData?._id);
                              }}
                            >
                              {columnData?.columnValue || ""}
                            </td>
                          );
                        })}
                        <td
                          onClick={() => {
                            setKitData(kitData);
                            setKitId(kitData?._id);
                          }}
                        >
                          {kitData?.kitNumber}
                        </td>
                        <td
                          className="text-capitalize"
                          onClick={() => {
                            setKitData(kitData);
                            setKitId(kitData?._id);
                          }}
                        >
                          {kitData?.kitType}
                        </td>
                        <td
                          onClick={() => {
                            setKitData(kitData);
                            setKitId(kitData?._id);
                          }}
                        >
                          {kitData?.depot}
                        </td>
                        <td
                          onClick={() => {
                            setKitData(kitData);
                            setKitId(kitData?._id);
                          }}
                        >
                          {kitData?.batchNumber}
                        </td>
                        <td
                          onClick={() => {
                            setKitData(kitData);
                            setKitId(kitData?._id);
                          }}
                        >
                          {(eiwrsPermission?.dbpCreateKitPreparation || eiwrsPermission?.liveCreateKitPreparation || eiwrsPermission?.qcCreateKitPreparation || eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ?
                            kitData?.treatment
                            :
                            <Badge style={{ width: 50 }} className="bg-danger hstack gap-1"><FaLock /> Blinded</Badge>
                          }
                        </td>
                        <td
                          onClick={() => {
                            setKitData(kitData);
                            setKitId(kitData?._id);
                          }}
                        >
                          {kitData?.expiryDate}
                        </td>
                        {columns?.filter(column => column?.isUnique === "no")?.map(item => {
                          const columnData = (kitData?.columns || [])?.find(
                            (ele) => ele?.columnName === item?.columnName
                          );
                          return (
                            <td
                              key={item?.columnId || item?.columnName}
                              onClick={() => {
                                setKitData(kitData);
                                setKitId(kitData?._id);
                              }}
                            >
                              {columnData?.columnValue || ""}
                            </td>
                          );
                        })}
                        <td
                          className={`fw-bold text-capitalize ${kitData?.status === "inPreparation"
                            ? "text-warning"
                            : kitData?.status === "released" ||
                              kitData?.status === "passedQC"
                              ? "text-success"
                              : kitData?.status === "pendingQC"
                                ? "text-secondary"
                                : kitData?.status === "expired" ||
                                  kitData?.status === "failedQC" ||
                                  kitData?.status === "rework"
                                  ? "text-danger"
                                  : "text-primary"
                            }`}
                          onClick={() => {
                            setKitData(kitData);
                            setKitId(kitData?._id);
                          }}
                        >
                          {kitData?.status === "inPreparation"
                            ? "In Preparation"
                            : kitData?.status === "pendingQC"
                              ? "Pending QC"
                              : kitData?.status === "failedQC"
                                ? "Failed QC"
                                : kitData?.status === "passedQC"
                                  ? "Passed QC"
                                  : kitData?.status}
                        </td>

                        {/* Action */}
                        <td
                          style={{ pointerEvents: "auto" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {kitData?.status === "created" ? (
                            <button
                              disabled={actionLoader}
                              onClick={() =>
                                statusConvertKitPreparation(
                                  kitData?._id,
                                  "inPreparation",
                                  "Start Assembly"
                                )
                              }
                              className="updateProfile"
                              style={{ padding: "1px 10px" }}
                            >
                              {actionLoader === kitData?._id ? (
                                <div className="hstack gap-2">
                                  <Spinner size="sm" /> Assembling Kit...
                                </div>
                              ) : (
                                "Start Assembly"
                              )}
                            </button>
                          ) : kitData?.status === "inPreparation" ? (
                            <button
                              onClick={() =>
                                statusConvertKitPreparation(
                                  kitData?._id,
                                  "pendingQC",
                                  "Submit to QC"
                                )
                              }
                              className="updateProfile"
                              style={{ padding: "1px 10px" }}
                            >
                              {actionLoader === kitData?._id ? (
                                <div className="hstack gap-2">
                                  <Spinner size="sm" /> Submitting...
                                </div>
                              ) : (
                                "Submit to QC"
                              )}
                            </button>
                          ) : kitData?.status === "pendingQC" ? (
                            <button
                              onClick={(e) => {
                                setKitData(kitData);
                                setToggle3();
                                e.stopPropagation();
                              }}
                              className="updateProfile"
                              style={{ padding: "1px 10px" }}
                            >
                              Run QC
                            </button>
                          ) : kitData?.status === "failedQC" ||
                            kitData?.status === "rework" ? (
                            <button
                              onClick={() =>
                                statusConvertKitPreparation(
                                  kitData?._id,
                                  "inPreparation",
                                  "Rework"
                                )
                              }
                              className="updateProfile"
                              style={{ padding: "1px 10px" }}
                            >
                              {actionLoader === kitData?._id ? (
                                <div className="hstack gap-2">
                                  <Spinner size="sm" /> Reworking...
                                </div>
                              ) : (
                                "Rework"
                              )}
                            </button>
                          ) : kitData?.status === "passedQC" ? (
                            <button
                              onClick={(e) => {
                                setKitData(kitData);
                                setToggle4();
                                e.stopPropagation();
                              }}
                              className="updateProfile"
                              style={{ padding: "1px 10px" }}
                            >
                              Released
                            </button>
                          ) : (
                            <button
                              onClick={() =>
                                statusConvertKitPreparation(
                                  kitData?._id,
                                  "available",
                                  "Stock at Depot"
                                )
                              }
                              className="updateProfile"
                              style={{ padding: "1px 10px" }}
                            >
                              {actionLoader === kitData?._id ? (
                                <div className="hstack gap-2">
                                  <Spinner size="sm" /> Stocking...
                                </div>
                              ) : (
                                "Stock at Depot"
                              )}
                            </button>
                          )}
                        </td>
                        {(eiwrsPermission?.dbpCreateKitPreparation || eiwrsPermission?.liveCreateKitPreparation || eiwrsPermission?.qcCreateKitPreparation) &&
                          <>
                            <td
                              className="text-center CP"
                              title={`Update ${kitData?.kitNumber}`}
                              onClick={(e) => {
                                setKitData(kitData);
                                setToggle();
                                e.stopPropagation();
                              }}
                              style={{ pointerEvents: "auto" }}
                            >
                              <FaEdit className="text-muted" />
                            </td>
                            <td
                              className="text-center CP"
                              title={`Delete ${kitData?.kitNumber}`}
                              onClick={(e) => {
                                e.stopPropagation();

                                softDeleteRestoreStudyKitPreparation(
                                  kitData?._id,
                                  "delete"
                                );
                              }}
                            >
                              <FaTrash className="text-danger" />
                            </td>
                          </>
                        }
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={kitCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </>
        </SplitPane>
        {kitId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setKitId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <KitPreparationActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                kitActivity={kitActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                kitData={kitData}
                kitActivityCount={kitActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudyKitPreparation
        Show={!toggle}
        Hide={setToggle}
        kitData={kitData}
        depotList={depotList}
        treatmentList={treatmentList}
        kitTypeList={kitTypeList}
        kitBatchList={kitBatchList}
        setKitId={setKitId}
        getStudyKitPreparationData={getStudyKitPreparationData}
        Title={"Update Kit"}
      />
      <ReleaseKitPreparation
        Show={!toggle4}
        Hide={setToggle4}
        kitData={kitData}
        depotList={depotList}
        setKitId={setKitId}
        getStudyKitPreparationData={getStudyKitPreparationData}
        Title={"Release kit"}
        eiwrsPermission={eiwrsPermission}
      />
      <RunQCKitPreparation
        Show={!toggle3}
        Hide={setToggle3}
        kitData={kitData}
        depotList={depotList}
        setKitId={setKitId}
        getStudyKitPreparationData={getStudyKitPreparationData}
        Title={"Run QC kit"}
        eiwrsPermission={eiwrsPermission}
      />
      <DeletedStudyKitPreparation
        Show={!toggle1}
        Hide={setToggle1}
        setKitId={setKitId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudyKitPreparation={deletedStudyKitPreparation}
        getDeletedStudyKitPreparation={getDeletedStudyKitPreparation}
        deletedStudyKitPreparationCount={deletedStudyKitPreparationCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyKitPreparation={softDeleteRestoreStudyKitPreparation}
        Title={"Deleted Kit History"}
      />
    </>
  );
};

export default StudyKitPreparationDataList;
